import Icon from 'veui/components/Icon'

Icon.register({
  broadcast: {
    paths: [
      {
        d: 'M480 704a32 32 0 01-14.31-3.38L216.45 576H64a32 32 0 01-32-32V224a32 32 0 0132-32h152.45L465.69 67.38A32 32 0 01512 96v576a32 32 0 01-32 32zM96 512h128a32 32 0 0114.31 3.38L448 620.22V147.78L238.31 252.62A32 32 0 01224 256H96v256zm640-128a32 32 0 00-32-32h-96a32 32 0 100 64h96a32 32 0 0032-32zm-37.25 272.56a32 32 0 00-9.19-44.31l-96-63a32 32 0 10-35.12 53.5l96 63a32 32 0 0044.31-9.19zM593.56 217.75l96-63a32 32 0 00-35.12-53.5l-96 63a32 32 0 1035.12 53.5z'
      }
    ],
    width: '768',
    height: '768'
  }
})
